import { HttpClient, serializeJSONApiData } from '@opallabs/api'
import loadWorkflow from '../loadWorkflow'

const prefixFor = (type, identifier) =>
  type && identifier ? `${type}/${identifier}/` : ''

const patchWorkflowPhaseItem = ({
  identifier,
  itemId,
  phaseId,
  params,
  type,
  workflowId,
}) =>
  HttpClient().patch(
    `/api/v1/${prefixFor(
      type,
      identifier
    )}workflow/${workflowId}/phases/${phaseId}/phase_items/${itemId}`,
    { data: params.data }
  )

const updateWorkflowPhaseItem =
  ({
    identifier,
    itemId,
    phaseId,
    onUpdatePhaseItem,
    postId,
    type = 'content',
    update,
    workflowId,
  }) =>
  (dispatch) => {
    const params = serializeJSONApiData(
      'phase-items',
      { ...update, id: itemId },
      false
    )
    const id = identifier || postId

    return patchWorkflowPhaseItem({
      type,
      identifier: id,
      workflowId,
      phaseId,
      itemId,
      params,
    })
      .then((response) => {
        if (onUpdatePhaseItem) {
          onUpdatePhaseItem()
        }
        return dispatch(loadWorkflow(response.data))
      })
      .catch((err) => {
        console.log(err)
        throw err
      })
  }

export default updateWorkflowPhaseItem
